<template>
  <div class="modal fade show" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <h5 class="modal-title">查看维修任务</h5>
          <div class="d-inline-flex justify-content-center align-items-center">
            <div class="dropdown topbar-head-dropdown">
              <button
                type="button"
                class="btn btn-topbar p-0"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  class="fs-18"
                  :class="
                    form.status && form.status == 'done'
                      ? 'ri-checkbox-circle-fill text-success'
                      : 'ri-forbid-fill text-muted'
                  "
                ></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end">
                <span
                  class="
                    dropdown-item
                    notify-item
                    language
                    py-1
                    d-inline-flex
                    justify-content-center
                    align-items-center
                  "
                  style="cursor: pointer"
                  @click="handleStatus('done')"
                >
                  完成<i
                    class="fs-18 ri-checkbox-circle-fill text-success ms-2"
                  ></i>
                </span>
                <span
                  class="
                    dropdown-item
                    notify-item
                    language
                    py-1
                    d-inline-flex
                    justify-content-center
                    align-items-center
                  "
                  style="cursor: pointer"
                  @click="handleStatus('pending')"
                >
                  未完成
                  <i class="fs-18 ri-forbid-fill text-muted ms-2"></i>
                </span>
              </div>
            </div>
            <i
              class="fs-18 ri-pencil-fill text-muted me-2 ms-2"
              @click="handleEdit()"
            ></i>
            <i
              class="fs-18 ri-delete-bin-6-fill text-muted"
              @click="handleDelete(form.id)"
            ></i>
            <button
              type="button"
              class="btn-close"
              @click="handleClose()"
            ></button>
          </div>
        </div>
        <form>
          <div class="modal-body">
            <div class="row gy-4 mb-3">
              <div class="col">
                <label for="start-field" class="form-label">
                  <span class="text-danger">*</span>开始时间</label
                >
                <div class="text-muted">
                  {{
                    form.repair_at &&
                    moment(form.repair_at).format("YYYY-MM-DD")
                  }}
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="name-field" class="form-label">
                  <span class="text-danger">*</span>设备
                </label>
                <div class="text-muted text-wrap text-break ms-2">
                  {{ form.equipment_snapshot }}
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-6 d-inline-flex align-items-center">
                <span> 导致产线停产 </span>
                <input
                  type="checkbox"
                  class="form-check-input ms-1 my-0"
                  :checked="form.properties.suspendedCheck"
                  disabled
                />
              </div>
              <div
                class="col-6 d-inline-flex align-items-center"
                v-if="form.properties.suspendedCheck"
              >
                <span>停产时长</span>
                <span class="text-muted ms-1" v-if="form.properties.downTime[0]"
                  >{{ form.properties.downTime[0] }}天</span
                >
                <span class="text-muted ms-1" v-if="form.properties.downTime[1]"
                  >{{ form.properties.downTime[1] }}时</span
                >
                <span class="text-muted ms-1" v-if="form.properties.downTime[2]"
                  >{{ form.properties.downTime[2] }}分</span
                >
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label">故障描述</label>
                <div class="text-muted text-wrap text-break ms-2">
                  {{ form.description || "-" }}
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label">解决方案</label>
                <div class="text-muted text-wrap text-break ms-2">
                  {{ form.properties.solution || "-" }}
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label">资料</label>
                <div
                  class="text-center text-muted"
                  v-if="!form.attachments || !form.attachments.length"
                >
                  无数据
                </div>
                <ul class="list-unstyled mb-0" id="dropzone-preview" v-else>
                  <div
                    class="border rounded"
                    v-for="(file, index) of form.attachments"
                    :key="index"
                  >
                    <div class="d-flex p-2">
                      <div class="flex-grow-1">
                        <div class="pt-1">
                          <h5 class="fs-14 mb-1">
                            <a
                              :href="file.url"
                              :download="file.url"
                              class="text-break"
                            >
                              {{ filterName(file.objectName) }}
                            </a>
                          </h5>
                          <p class="fs-13 text-muted mb-0">
                            <strong>{{ file.size / 1024 }}</strong> KB
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label">操作员</label>
                <div class="text-muted text-wrap text-break ms-2">
                  {{ form.operator || "-" }}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>
<script>
import _ from "loadsh";
import moment from "moment";
import { filterDurationTime } from "@/utils/common.js";

export default {
  emits: [
    "update:isShowReportForm",
    "handleAlert",
    "handleEdit",
    "handleDelete",
    "handleStatus",
  ],
  props: {
    isShowReportForm: Boolean,
    singleData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {
    return {};
  },
  components: {},
  watch: {
    singleData: {
      handler(newVal) {
        this.form = _.cloneDeep(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  mounted() {},
  data() {
    return {
      form: {},
      submitted: false,
    };
  },

  methods: {
    moment,
    filterDurationTime,
    handleClose() {
      this.$emit("update:isShowReportForm", false);
    },
    handleEdit() {
      this.$emit("update:isShowReportForm", false);
      this.$emit("handleEdit", this.form);
    },
    handleDelete(id) {
      this.$emit("handleDelete", id);
    },
    handleStatus(status) {
      let params = {
        repair_at: this.form.repair_at,
        equipment_id: this.form.equipment_id,
        end_date:
          status == "done" ? moment().format("YYYY-MM-DD HH:mm:ss") : null,
        status,
      };
      this.$emit("handleStatus", "report", this.form.id, params);
    },
    filterName(name) {
      if (/^(device\/)/.test(name)) {
        return name.substring(44);
      } else if (/^(reports\/)/.test(name)) {
        return name.substring(45);
      } else if (/^(events\/)/.test(name)) {
        return name.substring(44);
      } else {
        return name;
      }
    },
  },
};
</script>